import { Injectable } from '@angular/core';
import { SwUpdate, UnrecoverableStateEvent } from '@angular/service-worker';
import { environment } from 'environments/environment';
import { timer } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CheckForUpdateService {
  constructor(private updates: SwUpdate) {}

  init() {
    // App was never becoming stable (appRef.isStable) so wait 5 seconds instead
    timer(5 * 1000, environment.versionCheckInterval).subscribe(() =>
      this.updates.checkForUpdate(),
    );

    // SW entered an unrecoverable state (cached manifest no longer matches the server).
    // Reloading is the only option — the user would otherwise be stuck on broken chunks.
    this.updates.unrecoverable.subscribe((_event: UnrecoverableStateEvent) => {
      location.reload();
    });
  }
}
